import { render, staticRenderFns } from "./OverlaySendMailsExtern.vue?vue&type=template&id=4ab88903&scoped=true&"
import script from "./OverlaySendMailsExtern.vue?vue&type=script&lang=ts&"
export * from "./OverlaySendMailsExtern.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab88903",
  null
  
)

export default component.exports